import React from 'react';
import { ShieldCheck, CreditCard } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-brand-black bg-grid-pattern bg-grid-size pt-16 pb-20 px-4 overflow-hidden" data-id="element-32">
      {/* Subtle radial gradient overlay to focus center */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#18181b_100%)] pointer-events-none" data-id="element-33"></div>

      <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center z-10" data-id="element-34">
        <div className="inline-block mb-6 px-4 py-1.5 border border-brand-orange/30 bg-brand-orange/10 rounded-full" data-id="element-35">
          <p className="text-brand-orange font-montserrat font-bold text-sm md:text-base tracking-wider uppercase" data-id="element-36">
            For Families Living In U.S. Cities & Suburbs
          </p>
        </div>

        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 max-w-4xl" data-id="element-37">
          How To Secure Your Family's Safety In 72 Hours Without Buying A
          Bunker, Spending $10k On Gear, Or Looking Like A "Survivalist" To Your
          Neighbors
        </h1>

        <p className="text-zinc-300 text-lg md:text-xl max-w-3xl mb-12 font-opensans leading-relaxed" data-id="element-38">
          The Step-By-Step System for 2026. Protect your kids from grid
          failures, supply chain collapses, and urban chaos—even if you live in
          a small apartment.
        </p>

        <div className="w-full max-w-3xl mx-auto mb-12 relative" data-id="element-39">
          <div className="absolute -inset-4 bg-brand-orange/20 blur-2xl rounded-full opacity-50" data-id="element-40"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qHAWdiPKRx8hVycPcKmAAe/mockup_producto_2.png" alt="The Urban Autonomy System on iPad and iPhone" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-41" />
        </div>

        <div className="w-full max-w-md mx-auto flex flex-col items-center" data-id="element-42">
          <a href="#checkout" className="btn-crunchy w-full py-5 text-lg md:text-xl mb-4" data-id="element-43">
            YES! I WANT TO SECURE MY FAMILY FOR ONLY $9.99
          </a>

          <div className="flex items-center justify-center gap-4 text-zinc-400 text-sm font-medium" data-id="element-44">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-45" />
            <span data-id="element-46">Secure 256-bit Checkout</span>
          </div>
          <div className="flex items-center justify-center gap-3 mt-3 opacity-70" data-id="element-47">
            {/* Simple text representation of payment methods for trust */}
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-48">
              VISA
            </span>
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-49">
              MASTERCARD
            </span>
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-50">
              AMEX
            </span>
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-51">
              PAYPAL
            </span>
          </div>
        </div>
      </div>
    </section>;
}